import React from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import { Timeline, TimelineToPrint, TimelineTypeEnum } from 'types/timeline.types';

function getTitle(event: Timeline | TimelineToPrint, t: TFunction<'_common', undefined>) {
  if (event.type === TimelineTypeEnum.LOG) {
    return t('service_log');
  } else if (event.description) {
    return event.description;
  } else if (event.type === TimelineTypeEnum.SERVICE_ORDER && !event.description) {
    return t('service_order');
  }
  return '';
}

function getDescription(event: Timeline, t: TFunction<'_common', undefined>) {
  if (event.type === TimelineTypeEnum.LOG) {
    return event.description;
  } else if (event.event?.partitionCode && event.event?.partitionDescription) {
    return `${event.event?.partitionCode} - ${event.event?.partitionDescription}`;
  }
  return '';
}

function useTimelineDescription({ event }: { event: Timeline | undefined }) {
  const { t } = useTranslation('_common');

  const title = React.useMemo(() => (event ? getTitle(event, t) : ''), [event, t]);

  const description = React.useMemo(() => (event ? getDescription(event, t) : ''), [event, t]);

  return { title, description };
}

useTimelineDescription.getTitle = getTitle;

export default useTimelineDescription;
